import history from '../../util/history'

const toCreateTransactionView = reservationId => {
  history.push(`/reservation/${reservationId}/transaction`)

  return true
}

export default toCreateTransactionView
